import mapboxgl, { LngLat } from 'mapbox-gl'

import { IMapBoxFeature } from '~/client/src/shared/interfaces/IMapBoxFeature'

import { getMapBoxUrl } from './mapboxAddress'

// A leaf beside the URL builder, not on MapBoxViewer.store: five surfaces reverse-geocode a
// coordinate, and importing them from the store pulled in turf and six domain stores
// to do it.

const firstFeature = async (url: string): Promise<IMapBoxFeature> => {
  const resp = await fetch(url)
  const data: GeoJSON.FeatureCollection = await resp.json()
  return data.features[0] as IMapBoxFeature
}

export const getMapBoxPlaceFromBareCoordinates = (
  lng: number,
  lat: number,
  token: string,
): Promise<IMapBoxFeature> =>
  firstFeature(getMapBoxUrl(`${lng},${lat}`, token, false))

export const getMapBoxPlaceFromCoordinates = (
  coords: LngLat,
  token: string,
): Promise<IMapBoxFeature> =>
  firstFeature(getMapBoxUrl(`${coords.lng},${coords.lat}`, token, false))

export const getAddressFromCoords = (
  lat: number,
  lng: number,
): Promise<IMapBoxFeature> =>
  getMapBoxPlaceFromCoordinates(new LngLat(lng, lat), mapboxgl.accessToken)
